// @ts-check

import React, { Component, Fragment } from "react"
import { Link } from "react-router"
import { Card } from "ui"
import { direction as directionContext } from "features/editor/ContextProviders"
import { text } from "../../attributes/items/primitives"

/**
 * @augments {Component<BlockTypeProps>}
 */
class CardBlockType extends Component {
    /**
     * @type {(block: BlockConfig, context: BlockContext) => any} validate
     */
    static validate = (block, context) => {
        if (!block.config.attributes.objectId) {
            return "an objectId is required"
        }
    }
    static attributes = []
    render() {
        const { Wrapper } = this.props
        return (
            <Wrapper {...this.props}>
                {({ attrs, computedStyle, evaluateFormulas }) => {
                    const linkWrapper = children =>
                        attrs.link && evaluateFormulas(attrs.link).indexOf("://") == -1 ? (
                            <Link to={evaluateFormulas(attrs.link)}>{children}</Link>
                        ) : (
                            <a href={evaluateFormulas(attrs.link)}>{children}</a>
                        )
                    const wrapLink =
                        attrs.link && !this.props.context.editor.isEditing ? linkWrapper : a => a
                    return wrapLink(
                        <Fragment>
                            <Card style={{ ...computedStyle, width: "100%", height: "100%" }}>
                                <directionContext.Provider value="column">
                                    <div className="display-flex flex-column position-relative drop-here">
                                        {this.props.childBlocks.length === 0 ? (
                                            this.props.renderDroppable(null)
                                        ) : (
                                            <Fragment>
                                                {this.props.renderDroppable(
                                                    null,
                                                    this.props.childBlocks.length
                                                )}
                                                {this.props.utils.renderChildren(
                                                    this.props.childBlocks
                                                )}
                                            </Fragment>
                                        )}
                                    </div>
                                </directionContext.Provider>
                            </Card>
                        </Fragment>
                    )
                }}
            </Wrapper>
        )
    }
}

CardBlockType.propTypes = {}

CardBlockType.attributes = [text({ field: "link", label: "Link to page" })]

export default CardBlockType



// WEBPACK FOOTER //
// ./src/features/editor/blockTypes/entity/CardBlock.js